import { Avatar, Box, Fab, Modal, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import CloseIcon from '@mui/icons-material/Close';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import queryString from 'query-string';
import toast from 'react-hot-toast';
import { doc, getDoc, serverTimestamp, setDoc } from 'firebase/firestore';
import { v4 as uuidv4 } from 'uuid';
import { useSelector } from 'react-redux';
import Swal from 'sweetalert2';

import SafalLeaderBoard_Call from '../../assets/SafalLeaderBoard_Call.png';
import SafalLeaderBoard_Chat from '../../assets/SafalLeaderBoard_Chat.png';
import SafalLeaderBoard_Video from '../../assets/SafalLeaderBoard_Video.png';
import useProfileImage from '../../hooks/useProfileImage';
import useUserTimeZone, { getTimeZoneAbbreviation } from '../../hooks/useUserTimeZone';
import { firebasePushNotification, getSafalRoomUserInfo } from '../../services/Service';
import { db } from '../../firebase';
import UserChatModal from './UserChatModal';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 500,
  bgcolor: 'background.paper',
  border: '1px solid #000',
  borderRadius: '8px',
  boxShadow: 24,
  displey: 'flex',
  flexDirection: 'column',
  gap: '16px',
  padding: '24px',
  maxHeight: '95vh',
  overflow: 'auto',
  '@media (max-width: 640px)': {
    width: '95vw',
  },
};

export const UserMentionsModal = ({ open, onClose, userId, companyId }) => {
  const handleClose = () => {
    onClose();
  };
  const login = useSelector((state) => state.login);
  const { registered } = login.user;
  const { formatDate } = useUserTimeZone();
  const [userInfo, setUserInfo] = useState(null);
  const [userInfoMeta, setUserInfoMeta] = useState(null);
  const [userChatModal, setUserChatModal] = useState({
    open: false,
    otherUserId: '',
    type: 'chat', // chat. call
    user: null,
  });

  const profileImage = useProfileImage(userInfo?.profilePic);

  const fetchData = async () => {
    try {
      const res = await getSafalRoomUserInfo({ companyId, id: userId });
      if (res.status === 200) {
        setUserInfo(res.data.data);
        setUserInfoMeta(res.data.meta);
      }
    } catch (err) {
      console.log('OffersList fetchData error', err.message);
    }
  };
  // handle call/chat

  const [otherUserInfo, setOtherUserInfo] = useState(null);
  const currentFirebaseUser = useSelector((state) => state.currentFirebaseUser);
  const currentUserToUserChatEnable =
    currentFirebaseUser === null
      ? true
      : currentFirebaseUser.userToUserChat !== undefined
      ? currentFirebaseUser.userToUserChat
      : true;

  const isChatCallEnable = currentUserToUserChatEnable ? otherUserInfo?.userToUserChat === true : false;
  const fetchOtherUserFirebase = async (otherUserId) => {
    if (!otherUserId) return;
    const otherUserInfoRef = await getDoc(doc(db, 'users', otherUserId));
    if (otherUserInfoRef.exists()) {
      setOtherUserInfo(otherUserInfoRef.data());
    }
  };

  const onCallClick = async () => {
    onCallClickMain(userId, otherUserInfo, 'audio');
  };
  const onVideoClick = async () => {
    onCallClickMain(userId, otherUserInfo, 'video');
  };
  const onChatClick = async () => {
    onChatClickMain(userId, otherUserInfo);
  };
  const onCallClickMain = async (otherUserId, otherUserInfo, type) => {
    if (!registered) {
      Swal.fire('For added security, we kindly ask you to confirm your primary email before utilizing this feature.');
      return;
    }
    onConnectCall(otherUserInfo, type);
  };

  const onConnectCall = async (user, callModeX) => {
    const currentUserId = currentFirebaseUser.uid;
    const otherUserId = user?.uid;
    // user to user calls
    const otherUserDocDataRef = await getDoc(doc(db, 'users', otherUserId));
    const otherUserDocData = otherUserDocDataRef.data();
    const callId = uuidv4();
    const callLogRef = doc(db, 'callLogs', callId);
    const currentUserCallDocRef = doc(db, 'userCalls', currentUserId);
    const otherUserCallDocRef = doc(db, 'userCalls', otherUserId);
    try {
      const getDocData = await getDoc(otherUserCallDocRef);
      if (getDocData.exists) {
        const data = getDocData.data();
        if (data.isCall) {
          toast('User is busy in another call');
          return;
        }
      }
    } catch (err) {
      console.log(err);
    }
    const callMode = callModeX ?? 'audio';

    const callObj = {
      callId: callId,
      isCall: true,
      callMode: callMode, // audio/video,
      type: 'user',
      status: 'pending', // "pending", "accept", "reject", "end"
      currentUserId: currentUserId, // undefined or string
      otherUserId: otherUserId, // undefined or string
      flag: 'user_to_user', // user_to_user or support_to_user or user_to_support
      startAt: serverTimestamp(),
    };

    await setDoc(callLogRef, callObj);
    await setDoc(currentUserCallDocRef, callObj);
    await setDoc(otherUserCallDocRef, callObj);

    const notificationPayload = {
      data: {
        notification: { image: '', title: 'Calling', body: `${currentFirebaseUser?.displayName} calling you` },
        data: {
          type: 'call',
          messageId: '',
          otheruid: '',
          image_url: otherUserDocData?.photoURL,
          chatID: '',
          displayName: otherUserDocData?.displayName,
          userType: 'USER',
          isAudio: '1',
          OtherUid: currentUserId,
          channelId: callId,
        },
        apns: { payload: { aps: { sound: 'afro_ringtone.mp3', badge: 1 } } },
      },
      userId: otherUserDocData?.userID,
    };
    await firebasePushNotification(notificationPayload);
  };

  const handleUserChatClose = () => {
    localStorage.removeItem('SafalBuddyChat');
    localStorage.removeItem('SafalBuddyChatNew');
    setUserChatModal({
      open: false,
      otherUserId: '',
      type: 'chat', // chat. call
      user: null,
    });
  };

  const onChatClickMain = async (otherUserId, otherUserInfo) => {
    if (!registered) {
      Swal.fire('For added security, we kindly ask you to confirm your primary email before utilizing this feature.');
      return;
    }
    setUserChatModal({
      open: true,
      otherUserId: otherUserId,
      type: 'chat', // chat. call
      otherUserInfo: otherUserInfo,
    });
  };

  useEffect(() => {
    if (open) {
      fetchData();
      fetchOtherUserFirebase(userId);
    }
  }, [open, companyId, userId]);

  const fullName = `${userInfo?.firstName || ''} ${userInfo?.lastName || ''}`;
  return (
    <>
      <Modal open={open} onClose={handleClose}>
        <Box sx={style}>
          <Fab
            sx={{
              position: 'absolute',
              top: '10px',
              right: '10px',
              backgroundColor: '#3D71FF',
              color: 'white',
            }}
            onClick={handleClose}
            size="small"
            color="primary"
          >
            <CloseIcon />
          </Fab>
          <div style={{ display: 'flex', gap: '20px' }}>
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: '16px',
                padding: '8px 16px',
              }}
            >
              <Avatar sx={{ height: '72px', width: '72px' }} alt={fullName} src={profileImage} />
              <div style={{ display: 'flex', gap: '8px' }}>
                <button
                  onClick={onChatClick}
                  disabled={!isChatCallEnable}
                  style={{ border: 'none', backgroundColor: 'transparent', padding: '2px', cursor: 'pointer' }}
                >
                  <img
                    src={SafalLeaderBoard_Chat}
                    style={{
                      width: '20px',
                      height: '20px',
                      objectFit: 'contain',
                      filter: !isChatCallEnable ? 'grayscale(1)' : '',
                    }}
                    alt="SafalLeaderBoard_Chat"
                  />
                </button>
                <button
                  onClick={onCallClick}
                  disabled={!isChatCallEnable}
                  style={{ border: 'none', backgroundColor: 'transparent', padding: '2px', cursor: 'pointer' }}
                >
                  <img
                    src={SafalLeaderBoard_Call}
                    style={{
                      width: '20px',
                      height: '20px',
                      objectFit: 'contain',
                      filter: !isChatCallEnable ? 'grayscale(1)' : '',
                    }}
                    alt="SafalLeaderBoard_Call"
                  />
                </button>
                <button
                  onClick={onVideoClick}
                  disabled={!isChatCallEnable}
                  style={{ border: 'none', backgroundColor: 'transparent', padding: '2px', cursor: 'pointer' }}
                >
                  <img
                    src={SafalLeaderBoard_Video}
                    style={{
                      width: '20px',
                      height: '20px',
                      objectFit: 'contain',
                      filter: !isChatCallEnable ? 'grayscale(1)' : '',
                    }}
                    alt="SafalLeaderBoard_Video"
                  />
                </button>
              </div>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <span style={{ fontWeight: 'bold', fontSize: '20px' }}>{fullName}</span>
              <span style={{ color: '#3d71ff' }}>@{userInfo?.userID}</span>
              <span>
                <i>Email - </i>
                {userInfo?.email}
              </span>
              <span>
                <i>Active since - </i>
                {formatDate(userInfo?.createdAt)} {getTimeZoneAbbreviation()}
              </span>
              <span>
                <i>Mutual Buddies - </i>0
              </span>
              <span>
                <i>Total Post - </i>
                {userInfoMeta?.totalFeed}
              </span>
            </div>
          </div>
        </Box>
      </Modal>
      <UserChatModal
        open={userChatModal.open}
        buddyUser={userChatModal.otherUserInfo}
        handleClose={() => handleUserChatClose()}
      />
    </>
  );
};
